"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableRowHeight = void 0;
require("@veeam/components");
const types_1 = require("../types");
const getTableRowHeight = ({ rowHeight = types_1.TABLE_ROW_HEIGHT.auto, theme, }) => {
    let height;
    switch (rowHeight) {
        case types_1.TABLE_ROW_HEIGHT.compact:
            height = theme.spacing.l;
            break;
        case types_1.TABLE_ROW_HEIGHT.tall:
            height = theme.spacing.xxl;
            break;
        case types_1.TABLE_ROW_HEIGHT.normal:
        case types_1.TABLE_ROW_HEIGHT.auto:
        default:
            height = theme.spacing.xl;
    }
    return `height: ${height}`;
};
exports.getTableRowHeight = getTableRowHeight;
//# sourceMappingURL=getTableRowHeight.js.map